import React, { useState, useEffect } from "react";
import { Grid, Card, Modal, Header, Popup, Input } from "semantic-ui-react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteDatasets,
  DelRequestSuccess,
  editDataset,
  getDatasets,
  EditDatasetSuccess,
  deletePromptAction,
  deletePromptAndDatasetAction,
  deletePromptParameterAndDatasetAction,
} from "../../actions/dataConsoleAction";
import Loader from "../../components/Loader";

const DatasetLandingPage = ({
  columns,
  data,
  showToaster,
  setDeleteStatus,
  loaderFlag,
  setEditDatasetFlag,
  setData,
  setDatsetCount,
  datasetTypeEnabled,
  isAssistantDataset, // Added prop for dataset selection
  datasetDetails, // Receive dataset details as a prop
  onDatasetSelect,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);
  const { loadings, responseDelete, responseDeleteStatus } = useSelector(
    (state) => state.getdeleteDataSetReducer || {}
  );
  const { response } = useSelector(
    (state) => state.getlistDatasetReducer || {}
  );
  const { editDatasetResponse, editDataSetStatus } = useSelector(
    (state) => state.editDatasetReducer || {}
  );
  const orgDetails = useSelector((state) => state.admin.details);

  const [openDeletePromptBox, setOpenDeletePromptBox] = useState(false);
  const [deletePromptId, setDeletePromptId] = useState("");
  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [DesktopdeleteFlag, setDesktopdeleteFlag] = useState(false);
  const [deleteDatsetName, setdeleteDatsetName] = useState("");
  const [deleteDatsetId, setdeleteDatsetId] = useState("");
  const [editDatasetModelFlag, setEditDatasetModelFlag] = useState(false);
  const [datasetName, setDatasetName] = useState("");
  const [datasetDescription, setDatasetDescription] = useState("");
  const [datasetId, setDatasetId] = useState("");
  const [specialChar, setSpecialChar] = useState(true);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [lengthError, setLengthError] = useState(true);
  const [datasetExistError, setDatasetExistError] = useState("");
  const [editDatasetLoaderFlag, setEditDatasetLoaderFlag] = useState(false);
  const [deleteDatasetLoaderFlag, setDeleteDatasetLoaderFlag] = useState(false);
  const [checkdatasetName, setCheckdatasetName] = useState(false);
  const [initialDatasetName, setInitialDatasetName] = useState("");
  const [initialDatasetDescription, setInitialDatasetDescription] = useState("");
  const [openActionMenu, setOpenActionMenu] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (
      responseDeleteStatus &&
      responseDeleteStatus === 200 &&
      DesktopdeleteFlag
    ) {
      showToaster(`${deleteDatsetName} deleted successfully`, "success");
      setDeleteDatasetLoaderFlag(false);
      getDataSet();
      setDeleteStatus(true);
      setEditDatasetFlag(true);
      setDesktopdeleteFlag(false);
      dispatch(DelRequestSuccess([]));

    }
  }, [DesktopdeleteFlag, responseDelete, responseDeleteStatus, dispatch]);

  useEffect(() => {
    if (DesktopdeleteFlag) {
      const interval = setInterval(async () => {
        try {
          // Fetch the latest dataset list
          await dispatch(getDatasets());

          // Check if the deleted dataset ID is still present
          const latestDatasetIds = response?.map((dataset) => dataset.id) || [];

          if (!latestDatasetIds.includes(deleteDatsetId)) {
            // Dataset is successfully deleted
            setDeleteDatasetLoaderFlag(false);
            showToaster(`${deleteDatsetName} deleted successfully`, "success");
            setDesktopdeleteFlag(false); // Reset the flag
            clearInterval(interval); // Stop the interval
          }
        } catch (error) {
          console.error("Error in checking dataset deletion:", error);
          setDeleteDatasetLoaderFlag(false);
          setDesktopdeleteFlag(false);
          clearInterval(interval); // Stop the interval in case of error
        }
      }, 5000); // Run every 10 seconds

      return () => clearInterval(interval); // Cleanup on component unmount
    }
  }, [DesktopdeleteFlag, deleteDatsetId, deleteDatsetName, response, dispatch]);

  const getDataSet = () => {
    try {
      dispatch(getDatasets());
      setfilterDocdata(true);
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  useEffect(() => {
    if (response) {
      setDatsetCount(response.length);
      if (response.length > 0) {
        setData(response);
      }
    }
  }, [response, setDatsetCount]);

  useEffect(() => {
    setIsButtonEnabled(false);
    if (editDatasetResponse && editDataSetStatus) {
      if (editDataSetStatus === 200) {
        setEditDatasetFlag(true);
        showToaster("dataset updated successfully", "success");
        setEditDatasetLoaderFlag(false);
        setCheckdatasetName(false);
        setInitialDatasetName("");
        dispatch(EditDatasetSuccess([]));
        setEditDatasetModelFlag(false);
      } else {
        dispatch(EditDatasetSuccess([]));
        setEditDatasetModelFlag(true);
        setEditDatasetLoaderFlag(false);
        setDatasetExistError("Dataset name already exists");
      }
    }
  }, [dispatch, editDatasetResponse, editDataSetStatus]);

  const handleEdit = (name, id, isAssistantDataset) => {
    const selectedDataset = { name, id, isAssistantDataset };
    onDatasetSelect(selectedDataset);
    navigate(`/dataset/${id}/${name}`);
  };

  const handleEditDatasetModel = (dataset, description, id) => {
    setEditDatasetModelFlag(true);
    setDatasetName(dataset);
    setDatasetDescription(description);
    setDatasetId(id);
    setDatasetExistError("");
    setLengthError(true);
    setSpecialChar(true);
    setInitialDatasetName(dataset);
    setInitialDatasetDescription(description);
    setIsButtonEnabled(false);
  };

  const handleDelete = async (datasetName, datasetID, isReferenceDataset) => {
    // Prevent deletion of reference datasets
    if (isReferenceDataset) {
      showToaster(
        "Cannot delete reference dataset. Please change the reference dataset first in Configuration page.",
        "error"
      );
      return;
    }

    setdeleteDatsetName(datasetName);
    setdeleteDatsetId(datasetID);
    setOpenDeletePromptBox(true);
  };

  const actionDeleteDataset = async () => {
    setDesktopdeleteFlag(true);
    setOpenDeletePromptBox(false);
    setDeleteDatasetLoaderFlag(true);

    try {
      // Only call the dataset delete API
      await dispatch(deleteDatasets(deleteDatsetId));

      setData((prevData) =>
        prevData.filter((dataset) => dataset.id !== deleteDatsetId)
      );

      getDataSet();
    } catch (error) {
      console.error("Error in delete DataSet:", error);
      showToaster("Error in deleting dataset", "error");
      setDeleteDatasetLoaderFlag(false);
    }
  };

  const handleClose = () => {
    setOpenDeletePromptBox(false);
  };

  const handleCloseDatasetModel = async () => {
    setEditDatasetModelFlag(false);
    setCheckdatasetName(false);
    setIsButtonEnabled(false);
  };

  const totalItems = data.length;

  const getTimeAgo = (createdUTC) => {
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Updated today";
    } else if (timeDifference === 1) {
      return "Updated yesterday";
    } else {
      return `Updated ${timeDifference} days ago`;
    }
  };

  const handleChange = (event) => {
    setCheckdatasetName(true);
    setDatasetExistError("");

    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s'_\-()]/gi, "");

    setDatasetName(value);
    const hasSpecialChar = value !== sanitizedValue;
    setSpecialChar(!hasSpecialChar)

    const isValidLength = sanitizedValue.length <= 50;
    setLengthError(isValidLength);

    // Check if dataset name or description has changed
    const isNameChanged = sanitizedValue.trim() !== initialDatasetName.trim();
    const isDescriptionChanged = datasetDescription.trim() !== initialDatasetDescription.trim();

    if (isValidLength && !hasSpecialChar && (isNameChanged || isDescriptionChanged)) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  };

  const handleDescription = (event) => {
    const description = event.target.value;
    setDatasetDescription(description);

    // Check if dataset name or description has changed
    const isNameChanged = datasetName.trim() !== initialDatasetName.trim();
    const isDescriptionChanged = description.trim() !== initialDatasetDescription.trim();

    if (isNameChanged || isDescriptionChanged) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  };

  const handleDataSet = async () => {
    if (isButtonEnabled) {
      const finalStatus = initialDatasetName === datasetName ? false : true;
      const requestData = {
        datasetName: datasetName,
        description: datasetDescription,
        checkdatasetName: checkdatasetName ? finalStatus : checkdatasetName,
      };
      dispatch(editDataset(requestData, datasetId));
      setIsButtonEnabled(false);
      handleCloseDatasetModel();
      setEditDatasetLoaderFlag(true);
    }
  };

  return (
    <>
      {loaderFlag && <Loader />} {/* Loader component for add dataset */}
      {editDatasetLoaderFlag && <Loader />} {/*Loader component for edit dataset */}
      {deleteDatasetLoaderFlag && <Loader />} {/* Loader component for delete dataset */}

      <Grid columns={3} stackable className="users-table">
        {data.length > 0
          ? data.map((row) => (
            <Grid.Column
              key={row.id}
              onClick={() =>
                handleEdit(row.datasetName, row.id, row.isAssistantDataset)
              }
              data-cy="dataset-list-cy"
            >
              <Card fluid className="qac-card" data-cy="dataset-detail-link">
                <Card.Content>
                  {/* Top-right corner with REF tag and dataset icon */}
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                  >
                    {/* REF tag positioned to the left of the icon - only show if QuickChat is enabled */}
                    {row.isReferenceDataset && orgDetails?.quickChatDisabled && (
                      <Popup
                        content="Reference dataset for QuickChat configurations"
                        inverted
                        position="top center"
                        style={{ borderRadius: "15px" }}
                        trigger={
                          <span
                            style={{
                              backgroundColor: '#ebf8f2',
                              border: '1px solid #28a745',
                              borderRadius: '24px',
                              color: '#28a745',
                              padding: '4px 12px',
                              fontSize: '12px',
                              fontWeight: 'normal',
                              textTransform: 'none',
                              letterSpacing: 'normal',
                              display: 'inline-block',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            QuickChat Reference
                          </span>
                        }
                      />
                    )}

                    {/* ✅ New External User badge */}
                    {row.isExternalDataset && (
                      <Popup
                        content="This dataset is accessible to external users"
                        inverted
                        position="top center"
                        style={{ borderRadius: "15px" }}
                        trigger={
                          <span
                            style={{
                              backgroundColor: '#ede8ff',
                              border: '1px solid #6c63ff',
                              borderRadius: '24px',
                              color: '#4a3ddc',
                              padding: '4px 12px',
                              fontSize: '12px',
                              fontWeight: 'normal',
                              textTransform: 'none',
                              letterSpacing: 'normal',
                              display: 'inline-block',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            External User
                          </span>
                        }
                      />
                    )}

                    {/* Dataset type icon */}
                    <Popup
                      content={
                        row.isAssistantDataset
                          ? "Assistant powered embeddings and qna."
                          : "Advanced Embeddings and qna with Inferre."
                      }
                      inverted
                      position="top center"
                      style={{ borderRadius: "15px" }}
                      trigger={
                        <img
                          src={
                            row.isAssistantDataset
                              ? "/images/assistants.png"
                              : "/images/datasets.png"
                          }
                          alt={row.isAssistantDataset ? "Assistant Dataset" : "Dataset"}
                          style={{
                            width: row.isAssistantDataset ? "24px" : "30px",
                            height: row.isAssistantDataset ? "24px" : "26px",
                          }}
                        />
                      }
                    />
                  </div>

                  <Card.Header className="data-console-header">
                    <div style={{ paddingRight: '120px' }}>
                      {row.datasetName.length > 20 ? (
                        <Popup
                          content={row.datasetName}
                          inverted
                          position="right center"
                          style={{ borderRadius: "15px" }}
                          trigger={<div>{row.datasetName.slice(0, 20)}..</div>}
                        />
                      ) : (
                        <div>{row.datasetName}</div>
                      )}
                      {row.description && (
                        <div className="dataset-card-description">
                          {row.description.length > 50 ? (
                            <Popup
                              content={row.description}
                              inverted
                              position="right center"
                              style={{ borderRadius: "15px" }}
                              trigger={<span>{row.description.slice(0, 50)}...</span>}
                            />
                          ) : (
                            row.description
                          )}
                        </div>
                      )}
                      {!row.description && (
                        <div className="dataset-card-description">&nbsp;</div>
                      )}
                    </div>
                  </Card.Header>
                  <Card.Meta>
                    <div>
                      <div className="mobile-dataset-description-card">
                        <p></p>
                      </div>
                      <div className="mobile-dataset-document-card">
                        <p>
                          <span className="request-count-box">
                            {row.documentCount}
                          </span>{" "}
                          Documents
                        </p>
                        <p>
                          <span className="request-count-box">
                            {
                              row.accessUsers.filter(
                                (user) => user.accessType === "Approved"
                              ).length
                            }
                          </span>{" "}
                          Users
                        </p>
                      </div>
                    </div>
                  </Card.Meta>
                </Card.Content>
                <Card.Content extra className="qac-card-extra-content">
                  <div className="mobile-dataset-actions">
                    <p className="dataset-actions-view-details">
                      <Popup
                        trigger={<span>{getTimeAgo(row.createdUTC)}</span>}
                        content={new Date(
                          row.createdUTC
                        ).toLocaleDateString()}
                        position="top center"
                        inverted
                      />
                      &nbsp; &#x2022; &nbsp; {row.createdBy.displayName}
                    </p>
                    <p className="dataset-actions-delete">
                      <Popup
                        open={openActionMenu === row.id}
                        onOpen={(e) => {
                          e.stopPropagation();
                          setOpenActionMenu(row.id);
                        }}
                        onClose={() => setOpenActionMenu(null)}
                        on="click"
                        position="bottom right"
                        className="dataset-action-popup"
                        trigger={
                          <div
                            className="dataset-three-dot-btn"
                            onClick={(e) => e.stopPropagation()}
                            data-cy="dataset-action-menu"
                          >
                            <img
                              src="/images/chat-history-dots.svg"
                              alt="Actions"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        }
                      >
                        <div className="dataset-action-menu-list">
                          <div
                            className="dataset-action-menu-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenActionMenu(null);
                              handleEditDatasetModel(
                                row.datasetName,
                                row.description,
                                row.id
                              );
                            }}
                            data-cy="dataset-edit-link"
                          >
                            <img src="/images/Edit.svg" alt="Edit" />
                            <span>Edit</span>
                          </div>
                          <div
                            className="dataset-action-menu-item dataset-action-delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenActionMenu(null);
                              handleDelete(row.datasetName, row.id, row.isReferenceDataset);
                            }}
                            style={{
                              cursor: row.isReferenceDataset ? "not-allowed" : "pointer",
                              opacity: row.isReferenceDataset ? 0.5 : 1
                            }}
                            data-cy="dataset-delete-link"
                          >
                            <img src="/images/grey-delete.svg" alt="Delete" />
                            <span>Delete</span>
                          </div>
                        </div>
                      </Popup>
                    </p>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))
          : ""}
      </Grid>
      <Modal
        open={openDeletePromptBox}
        onClose={() => setOpenDeletePromptBox(false)}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Delete Dataset</Header>
          <p style={{ textAlign: "center" }}>
            Are you sure you want to delete the dataset "{deleteDatsetName}"
          </p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-dataset-delete"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={actionDeleteDataset}
            data-cy="delete-dataset-confirm"
          >
            Delete
          </button>
        </Modal.Actions>
      </Modal>
      <Modal
        open={editDatasetModelFlag}
        onClose={handleCloseDatasetModel}
        size="tiny"
        className="add-document-model"
      >
        <Modal.Content data-cy="error-message-cy">
          <Header as="h3">Edit dataset</Header>
          <label>Dataset name</label>
          <br />
          <Input
            type="text"
            value={datasetName}
            onChange={handleChange}
            placeholder="Add name"
            className="add-datset-input"
            data-cy="dataset-input-cy"
          />
          <br />
          {datasetName.length > 0 && !lengthError && (
            <span style={{ color: "red" }}>
              &nbsp;Maximum limit 50 characters.
            </span>
          )}
          {!specialChar && (
            <span style={{ color: "red" }}>
              &nbsp;Special characters are not allowed.
            </span>
          )}
          {datasetName.length > 0 && datasetExistError.length > 0 && (
            <span style={{ color: "red" }}>&nbsp;{datasetExistError}</span>
          )}
          <br />
          <p className="add-dataset-description">Dataset Description</p>
          <div className="add-dataset-description-textarea">
            <textarea
              rows="4"
              cols="50"
              className="add-datset-input"
              data-cy="dataset-description-cy"
              onChange={handleDescription}
              value={datasetDescription}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleCloseDatasetModel}
            data-cy="dataset-cancel-submit-btn"
          >
            Cancel
          </button>
          <button
            disabled={!isButtonEnabled}
            className="add-btn"
            onClick={handleDataSet}
            data-cy="dataset-submit-btn"
          >
            Save
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default DatasetLandingPage;
